import {
  MapPinGroupStatusTypeColor,
  MULTIPLE_STATUS_COLOR,
  Pin,
} from "interfaces/models/pin";
import { useCallback } from "react";
import { RootState } from "redux/store";
import { useSelector } from "react-redux";
import { getDbIdByExternalId } from "utils/forge/viewerData";

const useGetPinObjectDbIds = () => {
  const { isLoadedExternalId } = useSelector(
    (state: RootState) => state.forgeViewer
  );

  const getDbIdsFromPins = useCallback(
    (pins: Pin[]) => {
      if (!isLoadedExternalId) {
        return [];
      }

      const externalIds = pins.map((pin) => pin.objects || []).flat(1);

      return externalIds.map((externalId) => getDbIdByExternalId(externalId));
    },
    [isLoadedExternalId]
  );

  const getDbIdsWithColorFromPins = useCallback(
    (pins: Pin[], forceColor?: string) => {
      if (!isLoadedExternalId) {
        return [];
      }

      type Item = { color: string; pinId: string };
      const allDbIds: Record<number, Item[]> = {};

      // list db ids
      pins.forEach((pin) => {
        const color = forceColor
          ? forceColor
          : MapPinGroupStatusTypeColor[pin.status];

        pin.objects?.forEach((i) => {
          const dbId = getDbIdByExternalId(i);
          allDbIds[dbId] ??= [];
          allDbIds[dbId].push({ color, pinId: pin.id });
        });
      });

      return Object.keys(allDbIds).map((dbId) => {
        const list = (allDbIds as any)[dbId] as Item[];
        if (list.length > 1) {
          const colors = new Set(list.map(({ color }) => color));
          const combineColor =
            colors.size === 1 ? list[0].color : MULTIPLE_STATUS_COLOR;

          return {
            id: list[0].pinId,
            dbIds: [+dbId],
            color: combineColor,
          };
        } else {
          const { color, pinId } = list[0];

          return { id: pinId, dbIds: [+dbId], color };
        }
      });
    },
    [isLoadedExternalId]
  );

  return { getDbIdsFromPins, getDbIdsWithColorFromPins };
};

export default useGetPinObjectDbIds;
